import FullPageContainer from "components/FullPageContainer";
import styled from "styled-components";
import { getAppearFromLeft, getAppearFromRight } from "theme/animations";
import { breakpoints } from "theme/breakpoints";

export interface ExtraPaddingProps {
  extraPaddingTop: number;
  extraPaddingTopAnimationDuration: number;
}

const PopupsFullPageContainer = styled(FullPageContainer)<ExtraPaddingProps>`
  padding-bottom: 80px;
  box-sizing: border-box;
  background: linear-gradient(
    90deg,
    ${({ theme }) => theme.colors.secondary} 69%,
    ${({ theme }) => theme.colors.tertiary} 31%
  );
  transition: padding-top
    ${({ extraPaddingTopAnimationDuration }) =>
      extraPaddingTopAnimationDuration}s;
  padding-top: ${({ extraPaddingTop }) => extraPaddingTop}px;

  @media (max-width: ${breakpoints.lg}) {
    background: unset;
    background-color: ${({ theme }) => theme.colors.secondary};
  }

  .city-animation {
    position: absolute;
    width: 42%;
    transform: translate(0, 15%);
    right: 0;

    @media (max-width: ${breakpoints.lg}) {
      width: 65%;
      min-width: 400px;
    }

    @media (max-width: ${breakpoints.sm}) {
      top: 90px;
      width: 70%;
      min-width: 300px;
    }

    svg {
      animation: ${getAppearFromRight("20%")} 1s;
      animation-delay: 1s;
      animation-fill-mode: both;
    }
  }

  #logo {
    animation: ${getAppearFromLeft("-20%")} 0.7s;
    animation-fill-mode: both;
    animation-delay: 0.5s;
  }

  #button {
    animation: ${getAppearFromRight("20%")} 0.7s;
    animation-fill-mode: both;
    animation-delay: 0.5s;
  }

  #text {
    animation: ${getAppearFromLeft("-20%")} 1s;
    animation-delay: 1s;
    animation-fill-mode: both;
  }
`;

export default PopupsFullPageContainer;
